import { requestProjectApi } from 'serviceWorker/api/requestApi';
import { captureDataScope, DataOwner, type DataScope } from 'serviceWorker/helpers/dataScope';
import {
  announceLinkedDocumentationChange,
  removeLinkedDocumentationFromIssueRecord,
} from '../model';
import type {
  RemoveLinkedDocumentationRequest,
  RemoveLinkedDocumentationResultData,
} from 'shared/domain/issue/linkedDocumentation/operations';

function removeLinkedDocumentationRequest(issueId: string, linkedDocumentationId: string): Promise<void> {
  return requestProjectApi({ method: 'DELETE', path: `issue/${issueId}/linkedDocumentation/${linkedDocumentationId}` });
}

/** Unlinks the documentation from the issue on the server and in IndexedDB; rejects when the server refused. */
export async function removeLinkedDocumentation(
  detail: RemoveLinkedDocumentationRequest
): Promise<RemoveLinkedDocumentationResultData> {
  const { issueId, linkedDocumentationId } = detail;
  const scope = captureDataScope({ owner: DataOwner.PROJECT });
  await removeLinkedDocumentationRequest(issueId, linkedDocumentationId);
  await scope.write(async () => {
    await removeLinkedDocumentationFromIssueRecord(issueId, linkedDocumentationId);
    await announceLinkedDocumentationChange(issueId);
  });
  return { linkedDocumentationId };
}
